/**
 * Bottom Notification Bar JavaScript
 * Handles the display, timing, and local storage for the bottom notification bar
 * Uses page slug for page-specific local storage (shared across tabs, session only)
 */

function getSessionId() {
	// Use localStorage for session ID so it's shared across tabs
	let sessionId = localStorage.getItem('bottomNotificationSessionId');
	
	// Check if this is a new browser session by looking for any sessionStorage data
	const hasSessionData = sessionStorage.getItem('bottomNotificationActive');
	
	if (!sessionId || !hasSessionData) {
		// New session - create new ID and clear old notification data
		sessionId = Date.now().toString() + Math.random().toString(36).substr(2, 9);
		localStorage.setItem('bottomNotificationSessionId', sessionId);
		
		// Clear any old notification data
		const keys = Object.keys(localStorage);
		keys.forEach(key => {
			if (key.startsWith('bottomNotificationClosed_')) {
				localStorage.removeItem(key);
			}
		});
	}
	
	// Mark this tab as active for this session
	sessionStorage.setItem('bottomNotificationActive', 'true');
	
	return sessionId;
}

function cleanupPreviousSessionData() {
	// This is now handled in getSessionId()
}

function getCurrentPageSlug() {
	const path = window.location.pathname;
	const slug = path.split('/').filter(segment => segment).pop();
	return (slug && slug.trim() !== '') ? slug : 'home';
}

function closeBottomNotification() {
	const notification = document.getElementById('bottom-notification-bar');
	if (notification) {
		notification.classList.add('closing');
		setTimeout(() => {
			notification.style.display = 'none';
		}, 300);
		const pageSlug = getCurrentPageSlug();
		const sessionId = getSessionId();
		localStorage.setItem(`bottomNotificationClosed_${pageSlug}`, JSON.stringify({
			closed: true,
			sessionId: sessionId
		}));
	}
}

function initBottomNotification() {
	const sessionId = getSessionId();
	
	setTimeout(() => {
		const notification = document.getElementById('bottom-notification-bar');
		const pageSlug = getCurrentPageSlug();
		const storedData = localStorage.getItem(`bottomNotificationClosed_${pageSlug}`);
		
		let wasClosed = false;
		if (storedData) {
			try {
				const data = JSON.parse(storedData);
				if (data.sessionId === sessionId) {
					wasClosed = data.closed;
				} else {
					localStorage.removeItem(`bottomNotificationClosed_${pageSlug}`);
				}
			} catch (e) {
				localStorage.removeItem(`bottomNotificationClosed_${pageSlug}`);
			}
		}

		if (notification && !wasClosed) {
			notification.classList.add('show');
		}
	}, 3000);
}

document.addEventListener('DOMContentLoaded', function () {
	initBottomNotification();
});

window.closeBottomNotification = closeBottomNotification;
